<div class="ml-2 flex h-16 flex-row space-x-5">
  <div
    tp="Turn off formula to activate control"
    [tpIsEnabled]="isDisabled === true"
  >
    <ng-select
      #fractionYesnoTypeSelect
      [fixNgSelectBottom]="fractionYesnoTypeSelect"
      data-cy="fractionYesnoTypeSelect"
      class="fraction-type-select w-48"
      [items]="fractionYesnoTypesList"
      [clearable]="false"
      [searchable]="false"
      [disabled]="isDisabled === true"
      [(ngModel)]="fraction.type"
      (change)="typeChange($event)"
      (keyup.esc)="
        $event.stopImmediatePropagation(); fractionYesnoTypeSelect.blur()
      "
      (keyup.enter)="
        $event.stopImmediatePropagation(); fractionYesnoTypeSelect.blur()
      "
      appendTo="body"
      bindLabel="label"
      bindValue="value"
    >
      <ng-template ng-label-tmp let-item="item">
        <div class="ml-1 truncate">{{ item.label }}</div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item">
        <div
          class="flex flex-row"
          [ngClass]="{
            'text-yellow-700': item.operator === fractionOperatorEnum.And
          }"
        >
          <div class="ml-1">{{ item.operator | uppercase }} -</div>
          <div class="ml-1 truncate">{{ item.label }}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>

  <div
    *ngIf="fraction.type === fractionTypeEnum.YesnoIs"
    tp="Turn off formula to activate control"
    [tpIsEnabled]="isDisabled === true"
  >
    <ng-select
      #fractionYesnoValueSelect
      [fixNgSelectBottom]="fractionYesnoValueSelect"
      data-cy="fractionYesnoValueSelect"
      class="popup-55 w-48"
      [ngClass]="{
        'cursor-default': isDisabled === true
      }"
      [items]="fractionYesnoValuesList"
      [clearable]="false"
      [searchable]="false"
      [disabled]="isDisabled === true"
      [(ngModel)]="fraction.yesnoValue"
      (change)="yesnoChange($event)"
      (keyup.esc)="
        $event.stopImmediatePropagation(); fractionYesnoValueSelect.blur()
      "
      (keyup.enter)="
        $event.stopImmediatePropagation(); fractionYesnoValueSelect.blur()
      "
      appendTo="body"
      bindLabel="label"
      bindValue="value"
    >
      <ng-template ng-label-tmp let-item="item">
        <div class="ml-1 truncate">{{ item.label }}</div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item">
        <div class="ml-1 truncate">{{ item.label }}</div>
      </ng-template>
    </ng-select>
  </div>
</div>
